import MultisearchView from './View'

export default function install(Vue) {
  Vue.component('SearchV3View', MultisearchView)
}
